module.exports = __webpack_public_path__ + "img/outline_paqueteria.6bdfa335.svg";